module.exports = __webpack_public_path__ + "img/title4@2x.ce28d5df.png";